module.exports = __webpack_public_path__ + "img/thighcircumference.9d24173d.jpeg";